import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, mergeMap, retry, switchMap, tap } from 'rxjs/operators';

import { DepartmentsService } from '../../../../../../../ongoing/src/lib/services/departments/departments.service';

import * as departmentActions from '../actions/departments.actions';

@Injectable()
export class DepartmentsEffects {
  constructor(private actions$: Actions, private departmentsService: DepartmentsService) {}

  loadDepartments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(departmentActions.loadDepartments),
      mergeMap(() => {
        return this.departmentsService.loadPaginated().pipe(
          map(
            department => departmentActions.loadDepartmentsSuccess({ payload: department.result }),
            catchError(err => of(departmentActions.loadDepartmentsFail(err)))
          )
        );
      })
    )
  );

  loadMoreDepartments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(departmentActions.loadMoreDepartments),
      mergeMap(res => {
        return this.departmentsService.loadMore(res.payload.skip, res.payload.limit).pipe(
          map(department => departmentActions.loadMoreDepartmentsSuccess({ payload: department.result })),
          catchError(err => of(departmentActions.loadMoreDepartmentsFail(err)))
        );
      })
    )
  );

  loadAllDepartments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(departmentActions.loadAllDepartments),
      mergeMap(() => {
        return this.departmentsService.loadAll().pipe(
          map(department => departmentActions.loadAllDepartmentsSuccess({ payload: department.result.results })),
          catchError(err => of(departmentActions.loadAllDepartmentsFail(err)))
        );
      })
    )
  );

  searchDepartments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(departmentActions.searchDepartments),
      switchMap(res => {
        return this.departmentsService.search(res.payload).pipe(
          distinctUntilChanged(),
          debounceTime(500),
          map(department => departmentActions.searchDepartmentsSuccess({ payload: department.result.results})),
          catchError(err => of(departmentActions.searchDepartmentsFail(err)))
        );
      })
    )
  );
}
